import { Link, useLocation } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import Seo from "@/components/feature/Seo";

export default function NotFound() {
  const location = useLocation();

  return (
    <Layout>
      <Seo
        title="页面走丢了 - 樱花动漫"
        description="找不到你访问的页面，返回樱花动漫首页继续发现精彩动漫作品。"
        path={location.pathname}
      />
      <div className="flex min-h-[60vh] flex-col items-center justify-center px-4 text-center">
        <span className="flex h-20 w-20 items-center justify-center rounded-full bg-primary-100 text-4xl text-primary-500">
          <i className="ri-emotion-sad-line"></i>
        </span>
        <h1 className="mt-6 text-4xl font-black text-primary-500 md:text-6xl">404</h1>
        <h2 className="mt-3 text-lg font-semibold text-foreground-950">这个页面好像走丢了</h2>
        <p className="mt-2 max-w-md text-sm text-foreground-500">
          你访问的页面不存在或已移动，不如回到首页，继续寻找下一部心动之作。
        </p>
        <p className="mt-1 text-xs text-foreground-400">{location.pathname}</p>
        <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-home-4-line"></i>
            返回首页
          </Link>
          <Link
            to="/category/all"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-100 px-5 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
          >
            <i className="ri-apps-2-line"></i>
            浏览分类
          </Link>
        </div>
      </div>
    </Layout>
  );
}